import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  useTheme,
} from "@mui/material";
import SignalsControls from "./SignalsControls";
import SignalsDisplay from "./SignalsDisplay";
import { useSignalsState } from "../../hooks/useOptimizedState";

const SignalsContent = () => {
  const theme = useTheme();
  const [pasted, setPasted] = useState([]);
  const [strategyVal, setStrategyVal] = useState("");
  const [strategyValObj, setStrategyValObj] = useState();

  const [verifyEnabled, setVerifyEnabled] = useState(false);
  const [copiedData, setCopiedData] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [handleVerify, setHandleVerify] = useState(() => () => {});
  const [setSaveChange, setSaveChangeHandler] = useState(() => () => {});
  const [openBlacklistPopup, setBlacklistOpenPopup] = useState(false);
  const [numberOfBlacklistedObjects, setNumberOfBlacklistedObjects] = useState();
  const [numberOfInvalidObjects, setNumberOfInvalidObjects] = useState();
  const [numberOfNotVerifiedObjects, setNumberOfNotVerifiedObjects] = useState();
  const [empty, setEmpty] = useState(false);
  const [pasteButton, setPasteButton] = useState(false);
  const [error, setError] = useState("");
  

  const { strategies, blacklistSignal,isStrategist } = useSignalsState();

  const strategySelected = (id) => {
    if (id === null) {
      setStrategyValObj(undefined);
    } else {
      setStrategyValObj(id);
    }
  };

  const strategyList = strategies
    ?.map((i) => i?.name)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));


  return (
    <Grid container spacing={3}>
      {/* Controls Section */}
      <Grid item xs={12}>
        <Card
          sx={{
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: `1px solid ${theme.palette.divider}`,
            p: 3,
          
          }}
        >
          <SignalsControls
            strategyList={strategyList}
            strategyVal={strategyVal}
            setStrategyVal={setStrategyVal}
            strategyValObj={strategyValObj}
            strategySelected={strategySelected}
            strategies={strategies}
            pasted={pasted}
            setPasted={setPasted}
            setVerifyEnabled={setVerifyEnabled}
            setCopiedData={setCopiedData}
            setHandleVerify={setHandleVerify}
            setSaveChangeHandler={setSaveChangeHandler}
            setNumberOfInvalidObjects={setNumberOfInvalidObjects}
            setEmpty={setEmpty}
            setError={setError}
            error={error}
            empty={empty}
            blacklist={blacklistSignal}
            isStrategist={isStrategist}
            numberOfInvalidObjects={numberOfInvalidObjects}
            setSaveChange={setSaveChange}
          />
        </Card>
      </Grid>

      {/* Display Section */}
      <Grid item xs={12}>
        <Card
          sx={{
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: `1px solid ${theme.palette.divider}`,
            p: 3,
          }}
        >
          <SignalsDisplay
            strategies={strategies}
            strategyValObj={strategyValObj}
            strategyVal={strategyVal}
            pasted={pasted}
            setPasted={setPasted}
            setPasteButton={setPasteButton}
            setVerifyEnabled={setVerifyEnabled}
            copiedData={copiedData}
            setCopiedData={setCopiedData}
            setHandleVerify={setHandleVerify}
            setSaveChangeHandler={setSaveChangeHandler}
            setNumberOfInvalidObjects={setNumberOfInvalidObjects}
            setEmpty={setEmpty}
            setError={setError}
            error={error}
            empty={empty}
            numberOfInvalidObjects={numberOfInvalidObjects}
            blacklist={blacklistSignal}
            isStrategist={isStrategist}
          />
        </Card>
      </Grid>

    
    </Grid>
  );
};

export default SignalsContent; 